import React from 'react';

const logos = ['ASIANA', 'FEMINA', 'VOGUE', 'TLF'];

export default function Press() {
  return null;
}
